var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgListSettingsLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 18.5H9.5V20.5H2.5V18.5ZM2.5 11.5H11.5V13.5H2.5V11.5ZM2.5 4.5H22.5V6.5H2.5V4.5ZM21.174 13.525L22.33 13.134L23.33 14.866L22.414 15.671C22.5293 16.2177 22.5293 16.7823 22.414 17.329L23.33 18.134L22.33 19.866L21.174 19.475C20.764 19.845 20.276 20.13 19.739 20.305L19.5 21.5H17.5L17.26 20.304C16.7293 20.1306 16.2408 19.8478 15.826 19.474L14.67 19.866L13.67 18.134L14.586 17.329C14.4707 16.7823 14.4707 16.2177 14.586 15.671L13.67 14.866L14.67 13.134L15.826 13.525C16.236 13.155 16.724 12.87 17.261 12.695L17.5 11.5H19.5L19.74 12.696C20.276 12.87 20.764 13.156 21.174 13.526V13.525ZM18.5 18.5C19.0304 18.5 19.5391 18.2893 19.9142 17.9142C20.2893 17.5391 20.5 17.0304 20.5 16.5C20.5 15.9696 20.2893 15.4609 19.9142 15.0858C19.5391 14.7107 19.0304 14.5 18.5 14.5C17.9696 14.5 17.4609 14.7107 17.0858 15.0858C16.7107 15.4609 16.5 15.9696 16.5 16.5C16.5 17.0304 16.7107 17.5391 17.0858 17.9142C17.4609 18.2893 17.9696 18.5 18.5 18.5Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListSettingsLine);
export default __webpack_public_path__ + "static/media/list-settings-line.b35c4af9b35a52046d9c9f24f5985a7d.svg";
export { ForwardRef as ReactComponent };